import { Component } from "../../components/base/Component";
import { ICfa } from "../../models/ICfa";
import { ComponentFactory } from "../../services/ComponentFactory";
import { animationDebounce } from "../../util/AnimationDebounce";
import { Cookie } from "../../util/Cookie";

class InformBanner extends Component {
	private readonly frame: HTMLElement | null;

	constructor(element: HTMLElement, app: ICfa) {
		super(element, app);

		this.frame = document.querySelector(".frame");

		this.moveFrameDown();
		this.applyTopPosition();
		this.addCloseClickEvent();
		this.addResizeEvent();
	}

	private moveFrameDown(): void {
		if (this.frame) {
			this.frame.style.top = `${this._element.offsetHeight}px`;
		}
	}

	private addResizeEvent(): void {
		window.addEventListener(
			"resize",
			animationDebounce(
				() => window.innerWidth,
				width => this.transitionOnResize()
			)
		);
	}

	private transitionOnResize(): void {
		this.moveFrameDown();
		this.applyTopPosition();
	}

	private applyTopPosition(): void {
		let currentTopStickingPosition = this._element.offsetHeight;

		this.stickyNodes.forEach((node, i) => {
			node.style.top = `${currentTopStickingPosition}px`;
			currentTopStickingPosition += node.offsetHeight;
		});
	}

	private addCloseClickEvent(): void {
		const closeIcon = this._element.querySelector(".icon-close");
		if (!(closeIcon instanceof HTMLElement)) {
			throw new Error("expected closeIcon to be an HTMLElement");
		}
		closeIcon.addEventListener("click", event => {
			event.preventDefault();
			$(this._element).slideUp("fast");
			this.removeAddedStyles();
			this.setCookie(closeIcon);
		});
	}

	private removeAddedStyles(): void {
		this.stickyNodes.forEach(node => node.style.removeProperty("top"));
		this.frame?.style.removeProperty("top");
	}

	private setCookie(closeIcon: HTMLElement): void {
		const cookieId: string = closeIcon.dataset.href as string;
		const cookieName: string = closeIcon.dataset.cookie as string;
		const expireStamp: number = 86400000;
		Cookie.setBooleanCookie(cookieId, cookieName, expireStamp);
	}

	private get stickyNodes(): NodeListOf<HTMLElement> {
		return document.querySelectorAll("[data-sticky-position='true'");
	}
}

ComponentFactory.registerComponent("InformBanner", InformBanner);
